<template>
	<div>
		<div class="asd-margin" style="margin-top: 0px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/admin' }">智慧残联</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/admin/setting' }">人员管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="el-row" style="margin-top: 20px;">
			<el-button @click="addo()" size="mini" type="primary" icon="el-icon-plus">添加成员</el-button>
		</div>
		<el-table :max-height="gettbheight" :data="tableData" size="mini" border style="width: 100%;margin-top: 20px;">
			<el-table-column prop="uid" label="ID" width="50">
			</el-table-column>
			<el-table-column prop="name" label="姓名" width="180">
			</el-table-column>
			<el-table-column prop="phone" label="手机号">
			</el-table-column>
			<el-table-column prop="org_name" label="所属单位">
			</el-table-column>
			<el-table-column label="业务权限">
				<template slot-scope="scope">
					<el-tag size="mini" style="margin-right: 2px;" v-for="(p,i) in scope.row.role">{{p=="all"?'全部权限':p}}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button @click="changeA(scope.row)" type="text">修改信息</el-button>
					<el-button style="color:orange" @click="changePSD(scope.row.uid)" type="text">修改密码</el-button>
					<el-button style="color:red" type="text">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<addman ref="addman" v-model="addshow" :type="type" :shuju="shuju"></addman>
	</div>
</template>

<script>
	import addman from "../components/admins/addman.vue";
	import sm from "sm-crypto";
	export default {
		data() {
			return {
				tableData: [],
				addshow: false,
				type: false,
				shuju: {}
			}
		},
		components: {
			addman
		},
		computed: {
			gettbheight() {
				return window.innerHeight - 220;
			},
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			}
		},
		methods: {
			async delman(row) {
				let tt = await this.$confirm('此操作将永久删除该人员, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let ans = await axios.post(this.$url + "admin/delman", {
						token: this.info.uid,
						uid: row.uid
					});
					this.getdata();
					this.$message({
						type: 'success',
						message: '删除成功!'
					});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			changePSD(uid) {
				this.$prompt('请输入新密码', '修改新密码', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({
					value
				}) => {
					let npsd= sm.sm2.doEncrypt(value,
							"02a9fa092d95434eea7998ee6fa25a0abeda98496575685063608815fd9da1eb5c", 1);
					axios.post(this.$url + "admin/changePSD", {
						token: this.info.uid,
						uid: uid,
						newpsd: npsd
					}).then(ans => {
						this.$message({
							type: 'success',
							message: ans.data.desc
						});
					}).catch(e => {
						console.log(e);
					});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			changeA(row) {
				this.type = true;
				this.shuju = row;
				let roww = JSON.parse(JSON.stringify(row));
				roww.sms_tixing = roww.sms_tixing == 1 ? true : false;
				roww.allow_manage = roww.allow_manage == 1 ? true : false;
				this.$refs.addman.init(roww);
				this.addshow = true;
			},
			addo() {
			
				this.shuju = {};
				this.addshow = true;
				this.$refs.addman.init({
					name: "",
					org_id: "",
					idcard: "",
					password: "a.123456",
					phone: "",
					role: [],
					allow_manage: false,
					sms_tixing: false
				});
			},
			async getdata() {
				let ans = await axios.get(this.$url + "admin/mans", {
					params: {
						token: this.info.uid,
						org_id: this.org.org_id,
					}
				});
				this.tableData = ans.data.lists;
			}
		},
		created() {
			this.getdata();
		}
	}
</script>

<style>
</style>